export const tree = {
    tabs: {
        glossary: {
            cfg: ({ dconfig })=>dconfig.glossary?.on,
            datatype: [
                1,
                3,
                10,
                24
            ],
            parts: [
                'GlossaryManager'
            ],
            tabGroup: 'overview',
            order: 997
        }
    }
};
